import React, { useEffect } from 'react';

import PageSection from '../PageSections/PageSection';
import * as styles from './NobleSection.module.scss';

const NobleSection = ({ colorTheme }) => {
  const [containerClass, setContainerClass] = React.useState(styles.collapsed);
  const messageListener = (event) => {
    const type = event?.data?.bannerVisibility;
    if (type === 'bannerExpanded') {
      setContainerClass(styles.expanded);
    } else if (type === 'bannerCollapsed') {
      setContainerClass(styles.collapsed);
    }
  };

  useEffect(() => {
    if (typeof window == 'undefined') return;
    window.addEventListener('message', messageListener);
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, [setContainerClass]);

  if (process.env.GATSBY_ENABLE_NOBLE !== 'true') return null;

  return (
    <PageSection
      noPad={true}
      className={[styles.nobleFrameContainer, containerClass, styles[colorTheme?.toLowerCase()]].join(' ')}
    >
      <iframe
        title={'Noble Banner'}
        className={styles.nobleFrame}
        src="https://app.v2.thatsnoble.com/embed/?tenant-id=7880526e-3d0a-4dcd-a795-a5aacc49f92f&banner-embed=true"
        frameBorder="0"
        id="nobleIframe"
      ></iframe>
    </PageSection>
  );
};

export default NobleSection;
